import { useMemo } from 'react';

import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import flagAu from '../svg/au.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import flagUs from '../svg/us.svg';

const OptionItems = [
  { region: 'gb' as const, icon: faGlobe },
  { region: 'au' as const, svg: flagAu },
  { region: 'us' as const, svg: flagUs },
];

type RegionOption = {
  region: string;
  icon?: typeof faGlobe;
  svg?: string;
  label: string;
};

export function useGetTranslatedRegionOptions() {
  const { t } = useTranslation('regions');

  return useMemo(
    () =>
      OptionItems.map(
        (option) =>
          ({
            ...option,
            label: t(option.region),
          } as RegionOption),
      ),
    [t],
  );
}
